import React, { useState } from 'react';
import { Box } from '@mui/material';
import GoogleMapReact from 'google-map-react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// import mapStyles from './map-styles';

export const Map = ({ coordinate, setCoordinate }) => {
    const currentCoor = { lat: coordinate.latitude, lng: coordinate.longitude };
    const [defaultCoor, setDefaultCoor] = useState(coordinate);

    return (
        <Box height="50vh">
            <GoogleMapReact
                bootstrapURLKeys={{
                    key: 'AIzaSyA13Hw-OFYhkjWM6YXSqDdxk7-U1FLPztM',
                }}
                defaultCenter={currentCoor}
                center={currentCoor}
                defaultZoom={15}
                margin={[50, 50, 50, 50]}
                options={{
                    disableDefaultUI: true,
                    zoomControl: true,
                    scrollwheel: false,
                }}
                onClick={(res) => {
                    setCoordinate({
                        latitude: res.lat,
                        longitude: res.lng,
                    });
                    setDefaultCoor({
                        latitude: res.lat,
                        longitude: res.lng,
                    });
                }}
            >
                {coordinate && (
                    <div lat={defaultCoor.latitude} lng={defaultCoor.longitude}>
                        <LocationOnIcon
                            style={{ color: 'red', fontSize: '40' }}
                            fonts="large"
                        />
                    </div>
                )}
            </GoogleMapReact>
        </Box>
    );
};
